/* The brand name set the way the logo is drawn: lowercase "mirai" with gold dots over
   both i's, then "EDUCATIONS" in gold capitals. Screen readers and copy-paste get the
   plain name from the hidden text. */
const DotI = () => <span className="brand-i">ı</span>;

export const Brand = ({ className = "" }) => (
  <span className={`brand-mark ${className}`} translate="no" data-testid="brand-mark">
    <span className="sr-only">Mirai Educations</span>
    <span aria-hidden="true" className="brand-visual">
      <span className="brand-mirai">m<DotI />ra<DotI /></span>
      <span className="brand-edu">EDUCATIONS</span>
    </span>
  </span>
);

const NAME = /(Mirai Educations)/;

/* Swap every "Mirai Educations" inside a plain string for the styled brand mark. */
export const brandify = (text) => {
  if (typeof text !== "string" || !NAME.test(text)) return text;
  return text.split(NAME).map((part, i) => (part === "Mirai Educations" ? <Brand key={i} /> : part));
};
